import { TFindingStatus, TReviewSeverity, TReviewTypeId } from './types';

export const REVIEW_BASE_PATH = '/review';

export const REVIEW_TYPES: { id: TReviewTypeId; label: string; description: string }[] = [
  { id: 'full', label: 'Full review', description: 'Everything in scope against every selected basis' },
  { id: 'consistency', label: 'Consistency review', description: 'Statements and data across the selected documents' },
  { id: 'requirements', label: 'Requirements review', description: 'Coverage of the selected regulatory requirements' },
  { id: 'custom', label: 'Custom review', description: 'Guided by your instructions' },
];

export const SEVERITY_LABEL: Record<TReviewSeverity, string> = {
  major: 'Major',
  minor: 'Minor',
  needsReview: 'Needs review',
};

export const SEVERITY_ORDER: TReviewSeverity[] = ['major', 'minor', 'needsReview'];

export const STATUS_LABEL: Record<TFindingStatus, string> = {
  unresolved: 'Open',
  assigned: 'Assigned',
  dismissed: 'Not applicable',
  resolved: 'Resolved',
};

export const STATUS_ORDER: TFindingStatus[] = ['unresolved', 'assigned', 'dismissed', 'resolved'];

// Default run length of a review. A scenario can override it with
// `durationSeconds` when a demo needs more or less time on the progress screen.
export const DEFAULT_REVIEW_DURATION_MS = 12000;

export const DEFAULT_LOADING_MESSAGES = [
  'Reading documents',
  'Building product context',
  'Checking cross-document consistency',
  'Checking selected requirements',
  'Prioritizing findings',
];
